import React from 'react';
import { useTranslation } from 'react-i18next';
import GenericTablePage from '../components/GenericTablePage';
import { GridColDef } from '@mui/x-data-grid';
import { formatDate } from '../lib/dateUtils';

const PartnersPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.language === 'ar' ? 'ar' : 'en';
  
  const columns: GridColDef[] = [
    { field: 'pcu_id', headerName: t('partners.pcuId'), width: 120 },
    { field: 'name', headerName: t('partners.name'), flex: 1, minWidth: 200 },
    { 
      field: 'birth_date', 
      headerName: t('partners.birthDate'), 
      width: 150,
      valueFormatter: (value) => formatDate(value, locale, 'medium'),
    },
    { 
      field: 'registration_date', 
      headerName: t('partners.registrationDate'), 
      width: 150,
      valueFormatter: (value) => formatDate(value, locale, 'medium'),
    },
  ];

  const fields = [
    { 
      name: 'pcu_id', 
      label: t('partners.pcuId'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'name', 
      label: t('partners.name'), 
      type: 'text' as const, 
      required: true 
    },
    { 
      name: 'birth_date', 
      label: t('partners.birthDate'), 
      type: 'date' as const 
    },
    { 
      name: 'registration_date', 
      label: t('partners.registrationDate'), 
      type: 'date' as const 
    },
    { 
      name: 'company_id', 
      label: t('partners.company'), 
      type: 'select' as const,
      foreignKey: {
        table: 'companies',
        valueField: 'id',
        labelField: 'name'
      }
    },
  ];

  return (
    <GenericTablePage
      tableName="partners"
      title={t('partners.title')}
      columns={columns}
      fields={fields}
      selectQuery="*, company_id(name)"
      detailPath={(id) => `/partners/${id}`}
      editPath={(id) => (id ? `/partners/${id}/edit` : '/partners/new')}
    />
  );
};

export default PartnersPage;
